import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      style: {"position":"relative"},
      class: _normalizeClass(_ctx.inDrag ? 'drop-file drop-file-hover' : 'drop-file'),
      onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)), ["prevent"])),
      onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDragleave: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dragLeave && _ctx.dragLeave(...args)), ["prevent"])),
      onDragover: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args)), ["prevent"]))
    }, [
      (!_ctx.file)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.text), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.file.name), 1)),
      _createElementVNode("input", {
        style: {"position":"absolute","top":"0","bottom":"0","left":"0","right":"0","margin":"0","opacity":"0"},
        type: "file",
        accept: _ctx.pdfOnly ? '.pdf,application/pdf' : undefined,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mobileFile && _ctx.mobileFile(...args)))
      }, null, 40, _hoisted_3)
    ], 34)
  ]))
}